import type {
  AppCardTranslationsProps,
  AppCardAppStatus,
} from '../../AppCardTypes.types';

const getPromoAppStatusProps = (
  status: 'Promo' | undefined,
  detailedStatus: 'DiscountedCost' | 'FreeTrialPeriod' | undefined,
  translations: AppCardTranslationsProps | undefined
) => {
  switch (detailedStatus) {
    case 'DiscountedCost':
      return {
        status,
        costType: translations?.discountedCostTypeText ?? '',
        footerText: translations?.discountedCostFooterText ?? '',
      };
    case 'FreeTrialPeriod':
      return {
        status,
        costType: translations?.freeTrialPeriodCostTypeText ?? '',
        footerText: translations?.freeTrialPeriodFooterText ?? '',
      };
    default:
      return undefined;
  }
};

export const useAppStatusProps = (
  appStatus: AppCardAppStatus | undefined,
  translations: AppCardTranslationsProps | undefined
) => {
  const status = appStatus?.status;
  switch (status) {
    case 'Commissionable':
      return {
        status,
        costType: translations?.commissionableCostTypeText ?? '',
        footerText: translations?.commissionableFooterText ?? '',
      };
    case 'Commissioned':
      return {
        status,
        costType: translations?.commissionedCostTypeText ?? '',
        footerText: translations?.commissionedFooterText ?? '',
      };
    case 'Promo':
      return getPromoAppStatusProps(
        status,
        appStatus?.detailedStatus,
        translations
      );

    default:
      return undefined;
  }
};

export const useShouldHideCost = (appStatus: AppCardAppStatus | undefined) => {
  return (
    appStatus?.status === 'Promo' ||
    appStatus?.status === 'Commissioned' ||
    (appStatus?.status === 'Commissionable' &&
      appStatus.detailedStatus === 'CommissionableOnly')
  );
};
